import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ByteCompanionObjectClass;
function ByteCompanionObject() {
  if (ByteCompanionObjectClass === VOID) {
    class $ {
      constructor() {
        this.MIN_VALUE = -128;
        this.MAX_VALUE = 127;
        this.SIZE_BYTES = 1;
        this.SIZE_BITS = 8;
      }
      y5() {
        return this.MIN_VALUE;
      }
      z5() {
        return this.MAX_VALUE;
      }
      a6() {
        return this.SIZE_BYTES;
      }
      b6() {
        return this.SIZE_BITS;
      }
    }
    initMetadataForObject($, 'ByteCompanionObject');
    ByteCompanionObjectClass = $;
  }
  return ByteCompanionObjectClass;
}
var ByteCompanionObject_instance;
function ByteCompanionObject_getInstance() {
  return ByteCompanionObject_instance;
}
var ShortCompanionObjectClass;
function ShortCompanionObject() {
  if (ShortCompanionObjectClass === VOID) {
    class $ {
      constructor() {
        this.MIN_VALUE = -32768;
        this.MAX_VALUE = 32767;
        this.SIZE_BYTES = 2;
        this.SIZE_BITS = 16;
      }
      y5() {
        return this.MIN_VALUE;
      }
      z5() {
        return this.MAX_VALUE;
      }
      a6() {
        return this.SIZE_BYTES;
      }
      b6() {
        return this.SIZE_BITS;
      }
    }
    initMetadataForObject($, 'ShortCompanionObject');
    ShortCompanionObjectClass = $;
  }
  return ShortCompanionObjectClass;
}
var ShortCompanionObject_instance;
function ShortCompanionObject_getInstance() {
  return ShortCompanionObject_instance;
}
var IntCompanionObjectClass;
function IntCompanionObject() {
  if (IntCompanionObjectClass === VOID) {
    class $ {
      constructor() {
        this.MIN_VALUE = -2147483648;
        this.MAX_VALUE = 2147483647;
        this.SIZE_BYTES = 4;
        this.SIZE_BITS = 32;
      }
      y5() {
        return this.MIN_VALUE;
      }
      z5() {
        return this.MAX_VALUE;
      }
      a6() {
        return this.SIZE_BYTES;
      }
      b6() {
        return this.SIZE_BITS;
      }
    }
    initMetadataForObject($, 'IntCompanionObject');
    IntCompanionObjectClass = $;
  }
  return IntCompanionObjectClass;
}
var IntCompanionObject_instance;
function IntCompanionObject_getInstance() {
  return IntCompanionObject_instance;
}
var FloatCompanionObjectClass;
function FloatCompanionObject() {
  if (FloatCompanionObjectClass === VOID) {
    class $ {
      constructor() {
        this.MIN_VALUE = 1.4E-45;
        this.MAX_VALUE = 3.4028235E38;
        this.POSITIVE_INFINITY = Infinity;
        this.NEGATIVE_INFINITY = -Infinity;
        this.NaN = NaN;
        this.SIZE_BYTES = 4;
        this.SIZE_BITS = 32;
      }
      y5() {
        return this.MIN_VALUE;
      }
      z5() {
        return this.MAX_VALUE;
      }
      c6() {
        return this.POSITIVE_INFINITY;
      }
      d6() {
        return this.NEGATIVE_INFINITY;
      }
      e6() {
        return this.NaN;
      }
      a6() {
        return this.SIZE_BYTES;
      }
      b6() {
        return this.SIZE_BITS;
      }
    }
    initMetadataForObject($, 'FloatCompanionObject');
    FloatCompanionObjectClass = $;
  }
  return FloatCompanionObjectClass;
}
var FloatCompanionObject_instance;
function FloatCompanionObject_getInstance() {
  return FloatCompanionObject_instance;
}
var DoubleCompanionObjectClass;
function DoubleCompanionObject() {
  if (DoubleCompanionObjectClass === VOID) {
    class $ {
      constructor() {
        this.MIN_VALUE = 4.9E-324;
        this.MAX_VALUE = 1.7976931348623157E308;
        this.POSITIVE_INFINITY = Infinity;
        this.NEGATIVE_INFINITY = -Infinity;
        this.NaN = NaN;
        this.SIZE_BYTES = 8;
        this.SIZE_BITS = 64;
      }
      y5() {
        return this.MIN_VALUE;
      }
      z5() {
        return this.MAX_VALUE;
      }
      c6() {
        return this.POSITIVE_INFINITY;
      }
      d6() {
        return this.NEGATIVE_INFINITY;
      }
      e6() {
        return this.NaN;
      }
      a6() {
        return this.SIZE_BYTES;
      }
      b6() {
        return this.SIZE_BITS;
      }
    }
    initMetadataForObject($, 'DoubleCompanionObject');
    DoubleCompanionObjectClass = $;
  }
  return DoubleCompanionObjectClass;
}
var DoubleCompanionObject_instance;
function DoubleCompanionObject_getInstance() {
  return DoubleCompanionObject_instance;
}
var StringCompanionObjectClass;
function StringCompanionObject() {
  if (StringCompanionObjectClass === VOID) {
    class $ {}
    initMetadataForObject($, 'StringCompanionObject');
    StringCompanionObjectClass = $;
  }
  return StringCompanionObjectClass;
}
var StringCompanionObject_instance;
function StringCompanionObject_getInstance() {
  return StringCompanionObject_instance;
}
var BooleanCompanionObjectClass;
function BooleanCompanionObject() {
  if (BooleanCompanionObjectClass === VOID) {
    class $ {}
    initMetadataForObject($, 'BooleanCompanionObject');
    BooleanCompanionObjectClass = $;
  }
  return BooleanCompanionObjectClass;
}
var BooleanCompanionObject_instance;
function BooleanCompanionObject_getInstance() {
  return BooleanCompanionObject_instance;
}
//region block: init
ByteCompanionObject_instance = new (ByteCompanionObject())();
ShortCompanionObject_instance = new (ShortCompanionObject())();
IntCompanionObject_instance = new (IntCompanionObject())();
FloatCompanionObject_instance = new (FloatCompanionObject())();
DoubleCompanionObject_instance = new (DoubleCompanionObject())();
StringCompanionObject_instance = new (StringCompanionObject())();
BooleanCompanionObject_instance = new (BooleanCompanionObject())();
//endregion
//region block: exports
export {
  BooleanCompanionObject_instance as BooleanCompanionObject_instance2tls5h1cufcrh,
  ByteCompanionObject_instance as ByteCompanionObject_instance1r92wkzdy7g72,
  DoubleCompanionObject_instance as DoubleCompanionObject_instance43opzxl97v4p,
  FloatCompanionObject_instance as FloatCompanionObject_instanceokgc3apyetrg,
  IntCompanionObject_instance as IntCompanionObject_instance3g0jtywew2pgh,
  ShortCompanionObject_instance as ShortCompanionObject_instance33mqksfmw0mrs,
  StringCompanionObject_instance as StringCompanionObject_instance2dx16b5pp3v3z,
};
//endregion

//# sourceMappingURL=primitiveCompanionObjects.mjs.map
